import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { apiFetch } from './client';
import { keys } from './keys';

export const OverrideCoverageSchema = z.enum(['none', 'partial', 'full']);
export type OverrideCoverage = z.infer<typeof OverrideCoverageSchema>;

const DefaultUnpricedItemSchema = z.object({
  itemName: z.string(),
  phase: z.string().nullable().optional(),
  subPhaseName: z.string().nullable().optional(),
  supplier: z.string().nullable().optional(),
  missingLineCount: z.coerce.number().optional(),
  overriddenLineCount: z.coerce.number().optional(),
  overrideCoverage: OverrideCoverageSchema.optional().default('none'),
  trulyMissing: z.boolean().optional().default(true),
});

export type DefaultUnpricedItem = z.infer<typeof DefaultUnpricedItemSchema>;

const UnpricedResponseSchema = z.object({
  items: z.array(z.record(z.string(), z.unknown())),
  mtoOptions: z.array(z.record(z.string(), z.unknown())),
  defaultItems: z.array(DefaultUnpricedItemSchema),
});

export function useCommunityUnpriced(communityId: string | undefined) {
  return useQuery({
    queryKey: keys.communityUnpriced(communityId ?? ''),
    enabled: !!communityId,
    queryFn: () => apiFetch(`/api/communities/${communityId}/unpriced`, UnpricedResponseSchema),
  });
}
